<template>
  <div class="comment_form_wrapper">
    <form class="comment_form">
      <input
        type="text"
        v-model="comment"
        :placeholder="$t('commentPlaceHolder')"
        @focus="onFocus"
        @blur="onBlur"
        @keypress.enter.prevent.exact="postComment"
      />
      <img src="/img/comment.png" class="item_icon" @mousedown="postComment" />
    </form>
    <img
      src="/img/like.png"
      class="item_icon"
      v-show="!isFocused"
      @click="onIconClick"
    />
    <img
      src="/img/gift.png"
      class="item_icon"
      v-show="!isFocused"
      @click="onIconClick"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { comment } from '@/services/comment'
import { sendApiWarning, showGenericNetworkError } from '@/utils/handle_error'

@Component
export default class CommentForm extends Vue {
  @Prop()
  mediaId!: number

  isFocused = false
  comment: string = ''

  async postComment() {
    try {
      comment(this.mediaId, this.comment)
      this.comment = ''
    } catch (e) {
      sendApiWarning(e)
      showGenericNetworkError()
    }
  }

  onFocus() {
    this.isFocused = true
  }

  onBlur() {
    this.isFocused = false
  }

  @Emit('iconClick')
  onIconClick() {}
}
</script>

<style scoped>
.comment_form_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  height: 44px;
}

.item_icon {
  max-height: 44px;
  margin: 0 0 0 16px;
}

.comment_form img {
  margin: 0;
}

.comment_form img:hover {
  opacity: 0.6;
}

.comment_form {
  display: flex;
  width: 100%;
  background: rgba(38, 38, 38, 0.6);
  border-radius: 22px;
  padding: 0 8px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comment_form input {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  border: 0;
  color: #ffffff;
  background: none;
  margin: 0 0 0 14px;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
}

.comment_form input::placeholder {
  color: #ffffff;
}
</style>
